import _extends from "@babel/runtime-corejs3/helpers/extends";
import _valuesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/values";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _Object$values from "@babel/runtime-corejs3/core-js-stable/object/values";
import { DateField, InputField, SelectField } from '@unite-us/ui';
import { capitalize, debounce } from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import { Field } from 'react-final-form';
import today from '../../utils/today';
import { isRequired } from '../../utils/validations';
import { NON_SOCIAL_PLAN_TYPES } from '../constants';
import { useFindPlanOptions } from '../hooks/useFindPlanOptions';
import '../stylesheets/PaymentsInsuranceFields.scss';
export var PaymentsInsuranceFields = function PaymentsInsuranceFields(_ref) {
  var _context;
  var contactId = _ref.contactId,
    values = _valuesInstanceProperty(_ref),
    form = _ref.form,
    isEditing = _ref.isEditing,
    setFormErrors = _ref.setFormErrors;
  var _useFindPlanOptions = useFindPlanOptions({
      planType: values.plan_type,
      contactId: contactId
    }, !isEditing),
    planOptions = _useFindPlanOptions.planOptions,
    loadPlanOptions = _useFindPlanOptions.loadPlanOptions;
  var planTypeOptions = _mapInstanceProperty(_context = _Object$values(NON_SOCIAL_PLAN_TYPES)).call(_context, function (planType) {
    return {
      display_name: capitalize(planType),
      value: planType
    };
  });
  var onChangePlanType = function onChangePlanType() {
    form.change('plan_id', form.getFieldState('plan_id').initial);
    form.resetFieldState('plan_id');
  };
  var formValidator = {
    isRequiredValidator: function isRequiredValidator(values) {
      var isReq = isRequired(values);
      if (isReq !== null) {
        setFormErrors(isReq);
        return isReq;
      }
      return '';
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "payments-insurance-field"
  }, /*#__PURE__*/React.createElement(Field, {
    name: "plan_type"
  }, function (params) {
    return /*#__PURE__*/React.createElement(SelectField, _extends({
      className: "payments-insurance-fields__plan-type",
      disabled: isEditing,
      id: "plan-type",
      label: "Plan Type",
      labelKey: "display_name",
      onChange: onChangePlanType,
      options: planTypeOptions,
      placeholder: "Select...",
      required: true
    }, params));
  }), /*#__PURE__*/React.createElement(Field, {
    name: "plan_id",
    validate: formValidator.isRequiredValidator
  }, function (params) {
    return /*#__PURE__*/React.createElement(SelectField, _extends({
      className: "payments-insurance-fields__plan",
      disabled: isEditing,
      id: "insurance-plan",
      label: "Insurance Plan",
      loadOptions: debounce(loadPlanOptions, 400),
      options: _mapInstanceProperty(planOptions).call(planOptions, function (_ref2) {
        var id = _ref2.id,
          name = _ref2.name;
        return {
          value: id,
          label: name
        };
      }),
      placeholder: "Select...",
      required: true,
      searchResultLimit: 250,
      shouldSort: false,
      searchPlaceholderValue: planOptions.length === 0 ? 'Select Plan Type first' : 'Search'
    }, params));
  }), /*#__PURE__*/React.createElement("div", {
    className: "payments-insurance-info-item"
  }, /*#__PURE__*/React.createElement(Field, {
    name: "external_member_id",
    validate: formValidator.isRequiredValidator
  }, function (params) {
    return /*#__PURE__*/React.createElement(InputField, _extends({
      className: "payments-insurance-fields__member-id",
      id: "insurance-member-id",
      label: "Member Id",
      labelKey: "display_name",
      required: true
    }, params));
  })), /*#__PURE__*/React.createElement(Field, {
    name: "external_group_id"
  }, function (params) {
    return /*#__PURE__*/React.createElement(InputField, _extends({
      className: "payments-insurance-fields__group-id",
      id: "insurance-group-id",
      label: "Insurance Group Id"
    }, params));
  }), /*#__PURE__*/React.createElement("div", {
    className: "payments-insurance-date-item"
  }, /*#__PURE__*/React.createElement(Field, {
    name: "enrolled_at_converted"
  }, function (params) {
    return /*#__PURE__*/React.createElement(DateField, _extends({
      className: "payments-insurance-fields__coverage-start",
      id: "insurance-coverage-start",
      label: "Coverage Start",
      maxDate: values.expired_at_converted ? (Number(values.expired_at_converted) - 86400).toString() : null
    }, params));
  }), /*#__PURE__*/React.createElement(Field, {
    name: "expired_at_converted"
  }, function (params) {
    return /*#__PURE__*/React.createElement(DateField, _extends({
      className: "payments-insurance-fields__coverage-end",
      id: "insurance-coverage-end",
      label: "Coverage End",
      minDate: values.enrolled_at_converted ? (Number(values.enrolled_at_converted) + 86400).toString() : today(),
      isUtc: false,
      shouldDisableDate: function shouldDisableDate(date) {
        return date.isSame(moment.utc(values.enrolled_at_converted), 'day');
      }
    }, params));
  })));
};
PaymentsInsuranceFields.propTypes = {
  contactId: PropTypes.string.isRequired,
  values: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired,
  isEditing: PropTypes.bool.isRequired,
  setFormErrors: PropTypes.func.isRequired
};
//# sourceMappingURL=PaymentsInsuranceFields.js.map